import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FcpIconModule } from '../fcp-icon';
import { FcpCheckboxComponent } from './fcp-checkbox.component';
import { IndeterminateDirective } from './indeterminate.directive';

@NgModule({
    declarations: [FcpCheckboxComponent, IndeterminateDirective],
    imports: [FcpIconModule, CommonModule],
    exports: [FcpCheckboxComponent]
})
export class FcpCheckboxModule {}
